import React from "react";
import styled from "styled-components";
import { menu_bullet_list_src, sign_out_src } from "../images/index";
import { white } from "../constants/styles";
import { NotifButton } from "./Notification";
import { LoggedInUserContext } from "../providers/ProvideLoggedInUser";

const UnnamedComponent = (props) => {
  const { signedIn, currentUser, performLogout } =
    React.use(LoggedInUserContext);
  const name = React.useMemo(() => {
    if (!signedIn) return "U";
    if (signedIn && currentUser.name) {
      return currentUser.name;
    }
    return currentUser.email;
  }, [signedIn, currentUser]);
  const roles = currentUser?.roles;
  const menuItems = React.useMemo(
    () => [
      ...(!signedIn
        ? [
            {
              name: "Login",
              link: "/?login_popup_auto_shown=1",
              iconSrc: "",
            },
          ]
        : []),
      ...(roles?.includes("admin")
        ? [
            {
              name: "Admin",
              link: "/admin/dasboard",
              iconSrc: "",
            },
          ]
        : []),
      ...(roles?.includes("user")
        ? [
            {
              name: "Profile",
              link: "/profiles",
              iconSrc: "",
            },
            {
              name: "Membership",
              link: "/memberships",
              iconSrc: "",
            },
            {
              name: "Dashboard",
              link: "/dashboards",
              iconSrc: "",
            },
          ]
        : []),
      ...(roles?.includes("admin_company")
        ? [
            {
              name: "Dashboard Perusahaan",
              link: "/admin_company/dashboard",
              iconSrc: "",
              role: "admin_company",
            },
          ]
        : []),
      ...(roles?.includes("user_company")
        ? [
            {
              name: "Laporan User",
              link: "/admin_company/reports",
              iconSrc: "user_company",
              role: "user_company",
            },
          ]
        : []),
      ...(roles?.includes("affiliator")
        ? [
            {
              name: "Affiliator",
              link: "/users/affiliators",
              iconSrc: "",
              role: "affiliator",
            },
          ]
        : []),
    ],
    [signedIn, currentUser],
  );

  return (
    <NotifButton>
      <UserIcon
        src={`https://ui-avatars.com/api/?name=${name}${signedIn && "&background=9b855a&color=ffffff&bold=true"}`}
      />
      <MenuBox>
        {currentUser && (
          <MenuBoxTitle>
            {currentUser.name}
            <MenuBoxTitleEmail>{currentUser.email}</MenuBoxTitleEmail>
          </MenuBoxTitle>
        )}
        <MenuItemList>
          {menuItems.map((menu, idx) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <MenuItemLink key={idx} href={menu.link}>
              <MenuItemIcon>
                <img src={menu_bullet_list_src} />
              </MenuItemIcon>
              <MenuItemText>{menu.name}</MenuItemText>
            </MenuItemLink>
          ))}
          {signedIn && (
            <React.Fragment>
              <MenuLogoutSeparator />
              <MenuItemLink onClick={performLogout}>
                <MenuItemIcon>
                  <img src={sign_out_src} />
                </MenuItemIcon>
                <MenuItemText>Logout</MenuItemText>
              </MenuItemLink>
            </React.Fragment>
          )}
        </MenuItemList>
      </MenuBox>
    </NotifButton>
  );
};
export default UnnamedComponent;

const MenuBoxTitle = styled.div`
  background-image: linear-gradient(to right, #9b855a, #453b2b);
  border-radius: 5px;
  font-weight: bold;
  margin: 5px 13px;
  padding: 10px 5px;
`;

const MenuBoxTitleEmail = styled.div`
  font-size: 10px;
`;

const MenuItemList = styled.div`
  margin: 5px 13px;
`;

const MenuItemLink = styled.a`
  align-items: center;
  border-radius: 5px;
  color: ${white};
  cursor: pointer;
  display: flex;
  gap: 10px;
  padding: 7px 0;
  text-decoration: none;
  font-size: 13px;

  &:hover {
    background-color: #3f3f3f;
    text-decoration: underline;
  }
`;

const MenuItemIcon = styled.div`
  display: flex;
`;

const MenuItemText = styled.div``;

const UserIcon = styled.img`
  border-radius: 50%;
  width: 27px;
`;

const MenuBox = styled.div`
  background-color: #2f2f2f;
  color: ${white};
  cursor: default;
  display: none;
  max-height: 500px;
  overflow-y: auto;
  padding: 10px 0;
  position: absolute;
  right: 0;
  top: 35px;
  width: 200px;
  z-index: 1;

  ${NotifButton}:hover > & {
    display: block;
  }
`;

const MenuLogoutSeparator = styled.div`
  background-color: #ffffff9c;
  height: 1px;
  margin: 10px 0;
  width: 100%;
`;
